import { PropertyType } from './enums/property-type';

/**
 * Représente les critères d'un des filtres saisies par l'utilisateur dans le tableau de résultat de la recherche.
 */
export class FilterCriteria {
    /**
     * Constructeur
     * @param type : Type de propriété à filtrer.
     * @param value :  Valeur du filtre.
     */
    constructor(
        public type: PropertyType,
        public values: string[]
    ) {}

    /**
     * Instancie une instance de FilterCriteria
     * @param other : Representation JSON du FilterCriteria
     * @returns une instance de FilterCriteria
     */
    public static from(other) {
        if (!!other) {
            const instance = new FilterCriteria(other.type, other.values);
            return instance;
        } else {
            return null;
        }
    }
}
